export const FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS =
  'FLAG_GETTING_DRIVER_TASK_SUMMARY_MOVEMENTS';
export const GET_DRIVER_TASK_SUMMARY_MOVEMENTS =
  'GET_DRIVER_TASK_SUMMARY_MOVEMENTS';
export const FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY =
  'FLAG_GETTING_DRIVER_TASK_SUMMARY_MONTHLY';
export const GET_DRIVER_TASK_SUMMARY_MONTHLY =
  'GET_DRIVER_TASK_SUMMARY_MONTHLY';
export const CLEAR_DRIVER_TASK_SUMMARY = 'CLEAR_DRIVER_TASK_SUMMARY';